import { Injectable } from '@angular/core';
import { IOrdersSupportDetails, IWorkflowDialogData } from '@irb/irb-orders/irb-orders.model';

@Injectable({
  providedIn: 'root',
})
export class OrderStatusAction {
  nextAction: Function;
  constructor() { 
  }
  actionType(actionName:string,data:any){
    let msg;
    let itemsToProceed = [], msgList:any[] = [];
    let title = '';
    switch (actionName) {
      case 'VALIDATE':
         title='Validate';
        itemsToProceed = this.getValidateRecords(data);
        msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order(s) will be sent for validation.'):'None of the selected orders will be sent for validation.'
        break;
      case 'PLACE_TRADES_ON_HOLD':
         title='Place on Hold';
        itemsToProceed = this.getHoldRecords(data);
        msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order(s) will be placed on hold.'):'None of the selected orders can be placed on hold.'
        break;
      case 'MARK_AS_EXECUTED':
         title='Mark as Executed';
        itemsToProceed = this.getMarkExecutedRecords(data);
        msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order(s) will be marked as executed.'):'None of the selected orders can be marked as executed.'
        break;
      case 'REVERT_TO_APPROVED':
         title='Revert to Approved';
        itemsToProceed = this.getRevertApprovedRecords(data);
        msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order(s) will be reverted to approved.'):'None of the selected orders can be reverted to approved.'
        break;
      case 'SUBMIT':
         title='Submit';
         const submitObj = this.getSubmitRecords(data);
        itemsToProceed = submitObj.submitOrders;
        msgList = submitObj.msgList;
        break;
      case 'CANCEL':
         title='Cancel';
         const cancelObj = this.getCancelRecords(data);
         msgList = cancelObj.msgList;
        itemsToProceed = cancelObj.selectedRecords;
        msg = cancelObj.msg;
        break;
      case 'OVERRIDE':
         title='Override';
        itemsToProceed = this.getOverrideRecords(data);
        msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order warning(s) will be overridden.'):'None of the selected order warning(s) will be overridden.'
        break;
      // case 'REVERT_TO_APPROVED': //duplicate
      //    title='Revert to approved';
      //   itemsToProceed = this.getRevertApprovedRecords(data);
      //   msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order(s) will be overriden.'):'None of the selected orders can be overriden.'
      //   break;
      case 'MARK_AS_CANCELLED':
         title='Marked as Canceled';
        itemsToProceed = this.getMarkCancelledRecords(data);
        msg = itemsToProceed.length?(itemsToProceed.length + ' of ' + data.length + ' selected order(s) will be marked as canceled.'):'None of the selected orders can be marked as canceled.'
        break;
      case 'MULTI_EDIT':
        title='Edit Trade Instructions';
        const multilObj = this.getEditTradeInstructionsRecords(data);
        msgList = multilObj.msgList;
        itemsToProceed = multilObj.selectedRecords;
        msg = multilObj.msg;
        break;
      default:
          break ;
    }
    return this.createActionObj({
      msgList:msgList,
      content:msg,
      itemsToProceed: itemsToProceed,
      proceedBtnEnable:itemsToProceed.length?true:false,
      actionType:actionName,
      title:title
    });
  }
  createActionObj(data:any){
    if(data){
      return {
        msgList: data.msgList,
	      title: data.title,
	      nextAction: () => { this.nextAction()},
        content: data.content,
        proceedBtnEnable: data.proceedBtnEnable,
        itemsToProceed: data.itemsToProceed,
        actionType:data.actionType
      }
    }
  }
  getValidateRecords(records:any){
    return records.filter((entry:any)=> 
    ((entry.orderStatus == "APPROVED" || entry.orderStatus == "ERROR" || 
    entry.orderStatus == "VALIDATED" || entry.orderStatus == "WARNING" || 
    entry.orderStatus == "OVERRIDDEN") && entry.ticketType != "MANUAL")
    )
  }
  getHoldRecords(records:any){
    return records.filter((entry:any)=> 
    (entry.orderStatus == "APPROVED" || entry.orderStatus == "MANUALLY_SUBMITTED" || 
    entry.orderStatus == "PENDING_VALIDATION" || entry.orderStatus == "ERROR" || 
    entry.orderStatus == "VALIDATED" || entry.orderStatus == "OVERRIDDEN" || 
    entry.orderStatus == "WARNING" || entry.orderStatus == "EXPORTED_TO_THINK_PIPES")
    )
  }
  getMarkExecutedRecords(records:any){
    return records.filter((entry:any)=> 
    (entry.orderStatus == "APPROVED" || entry.orderStatus == "SUBMITTED_TO_VEO" || 
    entry.orderStatus == "MANUALLY_SUBMITTED" || entry.orderStatus == "WARNING" || 
    entry.orderStatus == "OVERRIDDEN" || entry.orderStatus == "REJECTED" || 
    entry.orderStatus == "ERROR" || entry.orderStatus == "VALIDATED" || entry.orderStatus == "EXPORTED_TO_THINK_PIPES")
    )
  }
  getRevertApprovedRecords(records:any){
    return records.filter((entry:any)=> 
    ((entry.orderStatus == "MANUALLY_SUBMITTED"
							 || entry.orderStatus == "ON_HOLD"
							 || (entry.orderStatus == "MARK_AS_EXECUTED" && (!entry.veoOrderID || entry.veoOrderID == null))
							 || entry.orderStatus == "PENDING_VALIDATION"
							 || (entry.orderStatus == "CANCELLED" && (!entry.veoOrderID || entry.veoOrderID == null)) //IREBAL-35317
							 || (entry.orderStatus == "CANCELLED_WITH_NO_FILL" && (!entry.veoOrderID || entry.veoOrderID == null)) //IREBAL-35317
							 || entry.orderStatus == "ERROR" || entry.orderStatus == "REJECTED"
							 || entry.orderStatus == "VALIDATED"
							 || entry.orderStatus == "OVERRIDDEN"
							 || entry.orderStatus == "EXPORTED_TO_THINK_PIPES"
							 || entry.orderStatus == "WARNING") && entry.ticketType != "A")
    )
  }
  getSubmitRecords(records:any){
    const submitOrders = records.filter((entry:any)=> 
    ((entry.orderStatus == "APPROVED" || entry.orderStatus == "VALIDATED" || entry.orderStatus == "OVERRIDDEN") && (entry.ticketType == "E" || entry.ticketType == "A"))
    );

    return this.getSubmitMsg({totalCount:records.length,canSubmitCnt:submitOrders.length},{submitOrders:submitOrders,records:records});
  }
  getSubmitMsg(count:any,submitOrdersObj?:any){
    const totalCount = count.totalCount;
    const canSubmitCnt = count.canSubmitCnt;
    const cannotSubmitCnt = totalCount - canSubmitCnt;
    let msgList: any[] = [];
		if (canSubmitCnt == 0) {
			msgList.push('0 orders will be submitted.');
			let nestedList: any[] = [];
            nestedList.push('They are in states other than Approved, Validated, or Overridden.');
            nestedList.push('They may be manual trades which cannot be submitted.');
			let msg = {msg:'None of the selected orders can be submitted because either:', nestedMsgList: nestedList};
			msgList.push(msg);
      /*msgList.push('None of the selected orders can be submitted because either:');
			msgList.push('They are in states other than: Approved, Validated, or Overridden.')
			msgList.push('They may be manual trades which cannot be submitted.');*/
			msgList.push('Please change these order states so that you can submit the orders.');
            msgList.push('To quickly view these orders, filter by order status.');

		} else if (cannotSubmitCnt == 0) {
			msgList.push(totalCount + ' of ' + totalCount + ' selected order(s) will be submitted.');
				
		} else {
			msgList.push(canSubmitCnt + ' of ' + totalCount + ' selected order(s) will be submitted.');
            let nestedList: any[] = [];

      // msgList.push('The orders that will not be submitted are either:');
      nestedList.push('In states other than Approved, Validated, or Overridden');
      nestedList.push('Or manual trades that cannot be submitted electronically (such as bonds and SMAs).');
      // msgList.push('in states other than: Approved, Validated, or Overridden');
      // msgList.push('or manual trades that cannot be submitted electronically (such as bonds and SMAs).');
      let msg = {msg:'The orders that will not be submitted are either:', nestedMsgList: nestedList};
      msgList.push(msg);
      msgList.push('To avoid overbuying accounts, please ensure that any manual sales are complete before electronically submitting buys that depend on the proceeds of those manual sales.');
      msgList.push('Please change these order states so that you can submit the orders. To quickly view these orders, filter by order status.');
    }
    return {
      msgList:msgList,
      submitOrders: (submitOrdersObj && submitOrdersObj.submitOrders)?submitOrdersObj.submitOrders:''
    }
  }
  getCancelRecords(records:any){
    let blockDeskRecords = 0, 
    selectedArr:any[] = [], 
    submittedOrdersArr = [], submitWithNoIdsArr = [],
    canReqOrdersArr = [], approvedOrdersArr = [];
    
    records.forEach((entry: any) => {
      if (entry.notHeldDestination == "AOM_PRINTER" && (entry.orderStatus == "SUBMITTED_TO_VEO" || entry.orderStatus == "PARTIALLY_FILLED")) {
        blockDeskRecords++;
        selectedArr.push(entry);
      } else {
        if (entry.orderStatus == "APPROVED" || entry.orderStatus == "SUBMITTED_TO_VEO" || entry.orderStatus == "MANUALLY_SUBMITTED" ||
          entry.orderStatus == "ON_HOLD" || entry.orderStatus == "MARK_AS_EXECUTED" || entry.orderStatus == "PARTIALLY_FILLED" ||
          entry.orderStatus == "REJECTED" || entry.orderStatus == "ERROR" || entry.orderStatus == "WARNING" ||
          entry.orderStatus == "PENDING_VALIDATION" || entry.orderStatus == "VALIDATED" || entry.orderStatus == "OVERRIDDEN" ||
          entry.orderStatus == "EXPORTED_TO_THINK_PIPES") {
          selectedArr.push(entry);
          if (entry.orderStatus == "SUBMITTED_TO_VEO") {
            submittedOrdersArr.push(entry);
            if (!entry.veoOrderID || entry.veoOrderID == null)
              submitWithNoIdsArr.push(entry);
          }
          if (entry.orderStatus == "APPROVED")
            approvedOrdersArr.push(entry);
        }
        if (entry.orderStatus == "CANCEL_REQUESTED") {
          canReqOrdersArr.push(entry);
        }

      }
  });
   return this.getCanceMsg( {
    submitWithNoIdsArr: submitWithNoIdsArr.length,
    selectedArr: selectedArr,
    itemsToProceedCount: selectedArr.length,
    AllItems: records.length,
    submittedOrdersArr: submittedOrdersArr.length,
    canReqOrdersArr: canReqOrdersArr.length,
    approvedOrdersArr: approvedOrdersArr.length,
    blockDeskRecords: blockDeskRecords,
    totalCancelRecords: (selectedArr.length - blockDeskRecords)
   });
   
  }

  getCanceMsg(objDt:any){
    let itemsToProceedCount = objDt.itemsToProceedCount,
    totalCount = objDt.AllItems,
    submitOrderCnt = objDt.submittedOrdersArr,
    approveOrderCnt = objDt.approvedOrdersArr,
    canReqOrderCnt = objDt.canReqOrdersArr,
    blockDeskRecords = objDt.blockDeskRecords,
    cannotCancelCnt = totalCount - (objDt.itemsToProceedCount - objDt.blockDeskRecords),
    markedAsCanceledCnt = totalCount - cannotCancelCnt,
    msg = '',
    msgList = [];

if (objDt.submitWithNoIdsArr > 0){
  msg = "No orders have been canceled. Please deselect any submitted orders that have not yet returned an order ID, or wait for an order ID to be received, and try your cancelation request again.";
} else if (itemsToProceedCount > 0) {
  msgList.push(markedAsCanceledCnt + ' of ' + totalCount + ' selected order(s) will be canceled.');

  if (submitOrderCnt > 0 || approveOrderCnt > 0 || canReqOrderCnt > 0 || cannotCancelCnt > 0) {
    if (submitOrderCnt > 0) {
      msgList.push(submitOrderCnt + " " + (submitOrderCnt == 1 ? "is in a " : "are in a") + " submitted state. The cancel request will be sent.");
    }

    if (approveOrderCnt > 0) {
      msgList.push(approveOrderCnt + " of " + (submitOrderCnt == 1 ? "this trade is" : "these trades are") + " approved. " + (submitOrderCnt == 1 ? "This" : "These") + " will be marked as canceled.");
    }

    if (cannotCancelCnt > 0) {
      msgList.push(cannotCancelCnt + " of " + totalCount + " selected trades cannot be marked as canceled.");

      if (canReqOrderCnt > 0) {
        msgList.push(canReqOrderCnt + " of " + (canReqOrderCnt == 1 ? "this trade is" : "these trades are") + " already in 'Cancel requested' status.");
      }
      if (blockDeskRecords > 0) {
        msgList.push(blockDeskRecords + (blockDeskRecords == 1 ? " of these trades was submitted to the block desk. This order " : " of these trades were submitted to block desk. These orders ") + "can only be canceled by contacting the block desk directly at " + "800-766-9922" + ".");
      }
    }
  }
} else {
  msg = "None of the selected orders can be canceled.";
}
    return{
      msg:msg,
      msgList:msgList,
      selectedRecords:msg?[]:objDt.selectedArr
    }
  }
  getOverrideRecords(records:any){
    return records.filter((entry:any)=> 
    (entry.orderStatus == "WARNING")
    )
  }
  getMarkCancelledRecords(records:any){
    return records.filter((entry:any)=> 
    (entry.orderStatus == "CANCEL_REJECTED" || entry.orderStatus == "CANCEL_REQUESTED")
    )
  }
  getEditTradeInstructionsRecords(records:any){
    let selectedArr:any[] = [];
    selectedArr = records.filter((entry:any)=> 
    (/*(entry.securityType == "Equity" || entry.securityType == "Option"  || entry.securityType == "Mutual Fund") && */(entry.orderStatus == "APPROVED" || entry.orderStatus == "WARNING"))
    )
    return this.getEditTradeMsg({
      AllItems:records,
      selectedArr:selectedArr
    });
  }
  getEditTradeMsg(objDt:any){
    const ordersArr = objDt.selectedArr,
    totalCount = objDt.AllItems.length,
    canEditCnt = ordersArr.length,
    cannotEditCnt = totalCount - canEditCnt;
    let msg = '', msgList = [];
 
 if (objDt.selectedArr.length > 0) {
  
  if (canEditCnt == 0) {
    msgList.push('0 orders will be edited.');
    msgList.push('None of the selected orders can be edited because either:');
    msgList.push('in states other than: Approved or Warning');
    msgList.push('or non-equity securities, in which the trade instructions cannot be edited (such as mutual funds and bonds).');
  } else if (cannotEditCnt == 0) {
    msgList.push( totalCount + ' of ' + totalCount + ' selected ' + ((totalCount > 1) ? 'orders' : 'order' + ' will be edited.'));	
  } else {	
    msgList.push(canEditCnt + ' of ' + totalCount + ' selected ' + ((canEditCnt > 1) ? 'orders' : 'order') + ' will be edited.');
    msgList.push('in states other than: Approved or Warning');
    msgList.push('or non-equity securities, in which the trade instructions cannot be edited (such as mutual funds and bonds).');
  }
 } else {
   msg = "None of the selected orders can be edited.";
 }
     return{
       msg:msg,
       msgList:msgList,
       selectedRecords:msg?[]:objDt.selectedArr
     }
   }

  getPostData(data:any,orderAction:string){
    let records:any[] = [];
    data.forEach((entry:any) => {
      records.push({
        orderID: entry.orderID,
        versionId: entry.versionId,
        ordIsNotHeld: entry.ordIsNotHeld,
        orderStatus: entry.orderStatus,
        transactionType: entry.transactionType,
        orderType:entry.orderType,
        expirationType:entry.expirationType,
        securityType:entry.securityType,
        securitySymbol:entry.securitySymbol,
        swapExchangeSymbol:entry.swapExchangeSymbol,
        isSwapExchange:entry.isSwapExchange,
        orderAction: orderAction,
        isActionChanged:true,
        notHeldDestination: entry.notHeldDestination,
        defaultOrderPriceType:entry.defaultOrderPriceType
      });
    });
    return records;
  }
  getSubmitWaringPostData(wfd:any){
    let records:any[] = [];
    wfd.itemsToProceed.forEach((entry:any) => {
      records.push({
        orderID: entry.orderID,
        transactionType: entry.transactionType,
        orderType:entry.orderType,
        expirationType:entry.expirationType,
        securityType:entry.securityType,
        orderAction: wfd.actionType
      });
    });
    return records;
  }
  getSubmitWarningMsg(response:any,osd:IOrdersSupportDetails){

    let msgArr = [];
    if (response.responseData.warnings.length > 0) {
      msgArr = response.responseData.warnings;
    }
    if (response.responseData.supportDetails.activeOrders > osd.activeOrders) {
      msgArr.push("There were additional trades for this environment which were approved from Portfolio Results and are not reflected in the blotter yet");
    }
    if ((response.responseData.supportDetails.lastUpdated - osd.lastUpdated) > 3600000) {
      msgArr.push("Equity Prices in blotter were updated before an hour.");
    }
		return {
      msgList: msgArr,
      title: 'Submit Warnings',
      nextAction: () => { },
      content: '',
      proceedBtnEnable: true,
      actionType:'SUBMIT'
    };
  }
  actionTypeAboveTreshold(actionName:string,objDt:any){
    let msg;
    let itemsToProceed:any[] = [], msgList:any[] = [], itemsToProceedCount:number = 0;
    let title = '';
    const selectedRecords = objDt['SELECTED'];
    switch (actionName) {
      case 'VALIDATE':
         title='Validate';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["APPROVED", "MANUALLY_SUBMITTED", "ERROR", "VALIDATED", "PENDING_VALIDATION", "OVERRIDDEN", "WARNING"]
          );
        msg = itemsToProceedCount?(itemsToProceedCount + ' of ' + selectedRecords + ' selected order(s) will be sent for validation.'):'None of the selected orders will be sent for validation.'
        break;
      case 'PLACE_TRADES_ON_HOLD':
         title='Place on Hold';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["APPROVED", "MANUALLY_SUBMITTED", "ERROR", "VALIDATED", "PENDING_VALIDATION", "OVERRIDDEN", "WARNING"]
          );
        msg = itemsToProceedCount?(itemsToProceedCount + ' of ' + selectedRecords + ' selected order(s) will be placed on hold.'):'None of the selected orders can be placed on hold.'
        break;
      case 'MARK_AS_EXECUTED':
         title='Mark as Executed';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["APPROVED", "MANUALLY_SUBMITTED", "SUBMITTED_TO_VEO", "REJECTED", "ERROR", "VALIDATED", "OVERRIDDEN", "WARNING"]
          );
        msg = itemsToProceedCount?(itemsToProceedCount + ' of ' + selectedRecords + ' selected order(s) will be marked as executed.'):'None of the selected orders can be marked as executed.'
        break;
      case 'REVERT_TO_APPROVED':
         title='Revert to Approved';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["MANUALLY_SUBMITTED", "ON_HOLD", "MARK_AS_EXECUTED", "PENDING_VALIDATION", "CANCELLED", "REJECTED", "CANCELLED_WITH_NO_FILL", "ERROR", "VALIDATED", "OVERRIDDEN", "WARNING", "EXPORTED_TO_THINK_PIPES"]
          );
        msg = itemsToProceedCount?(itemsToProceedCount + ' of ' + selectedRecords + ' selected order(s) will be reverted to approved.'):'None of the selected orders can be reverted to approved.'
        break;
      case 'SUBMIT':
         title='Submit';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["APPROVED", "VALIDATED", "OVERRIDDEN", "ELECTRONIC"]
          );
        const submitObj = this.getSubmitMsg(
          {totalCount:selectedRecords,canSubmitCnt:itemsToProceedCount});
           msgList = submitObj.msgList;
        break;
      case 'CANCEL':
         title='Cancel';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["APPROVED", "SUBMITTED_TO_VEO", "MANUALLY_SUBMITTED", "ON_HOLD", "MARK_AS_EXECUTED", "PARTIALLY_FILLED", "REJECTED", "ERROR", "VALIDATED", "OVERRIDDEN", "WARNING", "PENDING_VALIDATION"]
          );
        const blockDeskRecords = objDt['AOM_PRINTER']?objDt['AOM_PRINTER']:0;
        const cancelObj = this.getCanceMsg( {
        submitWithNoIdsArr: 0,
        selectedArr: [],
        itemsToProceedCount: itemsToProceedCount,
        AllItems: selectedRecords,
        submittedOrdersArr: objDt['SUBMITTED_TO_VEO']?objDt['SUBMITTED_TO_VEO']:0,
        canReqOrdersArr: objDt['CANCEL_REQUESTED']?objDt['CANCEL_REQUESTED']:0,
        approvedOrdersArr: objDt['APPROVED']?objDt['APPROVED']:0,
        blockDeskRecords: blockDeskRecords,
        totalCancelRecords: (itemsToProceedCount - blockDeskRecords)
       });

       msgList = cancelObj.msgList;
       itemsToProceed = cancelObj.selectedRecords;
       msg = cancelObj.msg;
        break;
      case 'OVERRIDE':
         title='Override';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["WARNING"]
          );
        msg = itemsToProceedCount?(itemsToProceedCount + ' of ' + selectedRecords + ' selected order(s) will be overridden.'):'None of the selected order warning(s) will be overridden.'
        break;
      case 'MARK_AS_CANCELLED':
         title='Marked as Canceled';
         itemsToProceedCount = this.getAboveTresholdActionTypeCount(objDt,
          ["CANCEL_REJECTED", "CANCEL_REQUESTED"]
          );
        msg = itemsToProceedCount?(itemsToProceedCount + ' of ' + selectedRecords + ' selected order(s) will be marked as canceled.'):'None of the selected orders can be marked as canceled.'
        break;
      // case 'MULTI_EDIT':
      //
      //   break;
      default:
          break ;
    }
    return {
      msgList:msgList,
      content:msg,
      itemsToProceed: itemsToProceed,
      itemsToProceedCount:itemsToProceedCount,
      proceedBtnEnable:itemsToProceedCount?true:false,
      actionType:actionName,
      title:title,
      nextAction: () => {}
    };
  }
  getAboveTresholdActionTypeCount(objDt:any,actionStatusTypeList:Array<string>){
    let totalcount:number = 0;
    actionStatusTypeList.forEach((node:any) => {
      if (objDt[node]) {
        totalcount += objDt[node];
      }
    });
    return totalcount;
  }
  isBlockDeskOrdersPresent(records:any,actionType:string){
    const blockdeskOrders = records.filter((entry:any)=> (entry.notHeldDestination == "AOM_PRINTER"));
    return (blockdeskOrders && blockdeskOrders.length && actionType == "SUBMIT") ? true: false;
  }
  orderActionSuccessMsgForBulk(actionName:string){
    switch (actionName) {
      case 'VALIDATE':
          return "The selected order(s) have been sent for validation.";
      case 'PLACE_TRADES_ON_HOLD':
          return "The selected order(s) have been placed on hold.";
      case 'MARK_AS_EXECUTED':
         return "The selected order(s) have been marked as executed.";
      case 'REVERT_TO_APPROVED':
         return "The selected order(s) have been reverted to approved.";
      case 'SUBMIT':
        return "The selected order(s) have been submitted. Refresh the blotter to view the Order IDs.";
      case 'CANCEL':
        return "The selected order(s) have been canceled.";
      case 'OVERRIDE':
         return "You have overridden the warnings.";
      // case 'REVERT_TO_APPROVED': //duplicate
      //   return "Your orders have been reverted.";
      case 'MARK_AS_CANCELLED':
         return "The selected order(s) have been marked as canceled.";
      case 'MULTI_EDIT':
        return "Your change has been saved.";
      default:
          return "Your change has been saved." ;
    }
  }
  

}
